import { Link } from "gatsby";
import styled from "styled-components";

import { Box, Image, VmSplitLogo } from "@vinomofo/components";
import WhiskyMofoLogo from "../../images/whiskymofo-logo.png";

export interface HeaderLogoProps {
  height?: string | Array<string>;
  isWhiskymofo?: boolean;
}

const HeaderLink = styled(Link)`
  display: block;
  height: 100%;

  @media ${({ theme }) => theme.mq.max.mobile} {
    height: 30px;
  }

  svg {
    width: auto;
    height: inherit;
    vertical-align: middle;
  }
`;

const StyledWhiskyMofoLogo = styled(Image)`
  width: auto;
  height: inherit;
  vertical-align: middle;
`;

export const HeaderLogo = ({
  height = "24px",
  isWhiskymofo,
}: HeaderLogoProps): JSX.Element => {
  return (
    <Box height={height}>
      <HeaderLink to={"/"}>
        {isWhiskymofo ? (
          <StyledWhiskyMofoLogo
            src={WhiskyMofoLogo}
            alt="Whisky Mofo Logo"
            width="100%"
          />
        ) : (
          <VmSplitLogo vinoColor="#77B204" mofoColor="#77B204" />
        )}
      </HeaderLink>
    </Box>
  );
};
